import * as ng from 'angular';
import * as moment from 'moment';

ng.module('e360')
   .filter('fdate', () => fdateFilter);

/**
 * Alternative to angularjs date filter. Ours uses momentjs to parse and format
 * dates, and provides a slightly different default format.
 * @param value
 * @param format
 * @param tzId when timezone ID is passed, append tz abbr and UTC offset
 */
export function fdateFilter(value:any, format?:string, tzId?:string):string {
   if (!value) {
      return '';
   }

   if (format == 'time') {
      format = 'h:mma';
   } else if (format == 'date') {
      format = 'MMM Do, YYYY';
   } else {
      format = 'MMM Do, YYYY h:mma';
   }

   let m = moment.isMoment(value) ? value : moment(value);

   if (tzId) {
      m = moment.tz(value, tzId);
      let offset = m.utcOffset() / 60;
      let offsetS = offset > 0? '+' + offset : '' + offset;
      format = `${format} [${m.zoneAbbr()} (UTC${offsetS})]`;
   }

   return m.format(format);
}
